import { RefreshCw } from "lucide-react";
import { PERIOD_OPTIONS } from "../constants";

/** Dropdown de período + botão de refresh. */
export function PeriodSelector({ days, setDays, onRefresh }) {
  return (
    <div className="flex items-center gap-2">
      <select
        value={days}
        onChange={(e) => setDays(parseInt(e.target.value, 10))}
        className="px-3 py-2 rounded-lg border bg-background text-sm"
      >
        {PERIOD_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <button
        type="button"
        onClick={onRefresh}
        className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border hover:bg-muted text-sm"
      >
        <RefreshCw className="w-4 h-4" /> Atualizar
      </button>
    </div>
  );
}
